/**
 * the-gama entry point.
 *
 * Routes:
 *   /                  -> Homepage (404-parody)
 *   /alaia-chella/*    -> Alaia's birthday invite + RSVP
 *
 * Alaia World (the hide-and-seek game, /alaia) isn't launching through the
 * website yet — its code stays under src/experiences/alaia-world for later,
 * just unrouted for now. Future siblings (/papa, /mama) slot in alongside.
 */

import './shared/styles.css';

const root = document.getElementById('app');
if (!root) throw new Error('#app not found in index.html');

const route = window.location.pathname;

// body.in-rsvp -> CSS scopes the festival background to /alaia-chella/* only.
document.body.classList.toggle('in-rsvp', route.startsWith('/alaia-chella'));

if (route === '/' || route === '') {
  void import('./home').then(({ mountHome }) => mountHome(root));
} else if (route.startsWith('/alaia-chella')) {
  void import('./rsvp').then(({ mountRsvp }) => mountRsvp(root, route));
} else {
  // Any unknown route falls back to the homepage — which is already a 404.
  void import('./home').then(({ mountHome }) => mountHome(root));
}
